import React from 'react';

import styles from '../../../utils/styles';
import './StickyPlayerHeader.scss';
import TypograpyBodyComponent from '../../foundation/typography/typography-body/typography-body';
import IconClose from '../../atoms/icons/icon-close';

export interface IStickyPlayerHeader {
  title: string;
  onClickClose: () => void;
  isDesktop: boolean;
  showCloseBtn: boolean;
}

const StickyPlayerHeader: React.FC<IStickyPlayerHeader> = ({
  title,
  onClickClose,
  isDesktop = false,
  showCloseBtn = false,
}) => {
  const className = styles('sticky-player-header');
  return (
    <div className={className} onClick={onClickClose}>
      <TypograpyBodyComponent
        text={title.toUpperCase()}
        typographyClass={styles('ty-body-xsmall-medium sticky-player-header__title')}
      />
      {showCloseBtn && (
        <div className={styles('sticky-player-header__icon')}>
          <IconClose size={isDesktop ? 'small' : 'xsmall'} width={isDesktop ? '30' : '20'} />
        </div>
      )}
    </div>
  );
};

export default StickyPlayerHeader;
